import { useEffect, useState } from 'react'
import { Activity, AlertTriangle, CheckCircle2, Loader2 } from 'lucide-react'
import { kassaAPI } from '@/lib/api'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { RefreshCw } from 'lucide-react'

export default function KassaAdminStatus() {
  const [status, setStatus] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const load = () => {
    setLoading(true)
    kassaAPI.getSyncStatus()
      .then(res => { setStatus(res.data); setError(null) })
      .catch(err => setError(err.response?.data?.error || err.message))
      .finally(() => setLoading(false))
  }

  useEffect(() => { load() }, [])

  const queue = status?.node?.queue || {}
  const applied = queue.applied ?? 0
  const pending = queue.pending ?? 0
  const conflicts = queue.conflicts ?? 0
  const hasIssues = conflicts > 0 || pending > 0
  const kassaUrl = typeof window !== 'undefined' && window.location.hostname.endsWith('.ts.net')
    ? 'https://clubkassa.tail9a4b92.ts.net/admin/sync/wachtrij'
    : 'http://clubkassa.local:5000/admin/sync/wachtrij'

  return (
    <div className="p-3 rounded-lg border border-border/50 bg-card/50 space-y-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2 text-sm font-medium">
          {loading ? <Loader2 className="h-4 w-4 animate-spin text-muted-foreground" />
            : error ? <AlertTriangle className="h-4 w-4 text-destructive" />
            : hasIssues ? <AlertTriangle className="h-4 w-4 text-yellow-500" />
            : <CheckCircle2 className="h-4 w-4 text-green-500" />}
          Sync-wachtrij
        </div>
        <div className="flex items-center gap-1">
          <Button variant="ghost" size="sm" className="h-7 px-2" onClick={load} disabled={loading}>
            <RefreshCw className="h-3.5 w-3.5" />
          </Button>
        </div>
      </div>
      {error ? (
        <p className="text-xs text-destructive">Kassa niet bereikbaar: {error}</p>
      ) : (
        <div className="flex flex-wrap gap-2 text-xs">
          <Badge variant="outline" className="gap-1"><CheckCircle2 className="h-3 w-3 text-green-500" />{applied} applied</Badge>
          <Badge variant="outline" className="gap-1"><Activity className="h-3 w-3 text-yellow-500" />{pending} pending</Badge>
          <Badge variant={conflicts > 0 ? 'destructive' : 'outline'} className="gap-1">
            <AlertTriangle className="h-3 w-3" />{conflicts} conflicts
          </Badge>
          <span className="text-muted-foreground ml-auto">seq {status?.latest_sequence ?? '—'}</span>
        </div>
      )}
      {conflicts > 0 && (
        <a href={kassaUrl} target="_blank" rel="noopener noreferrer"
           className="block text-xs text-neon-blue hover:underline">
          → Open sync-wachtrij in kassa
        </a>
      )}
    </div>
  )
}
